import { GOOGLE_MAPS_CONFIG } from '@/config/googleMaps';
import { APIProvider, Map, Marker } from '@vis.gl/react-google-maps';

interface GoogleMapProps {
  latitude: number;
  longitude: number;
  title: string;
}

const GoogleMap = ({ latitude, longitude, title }: GoogleMapProps) => {
  return (
    <div className="w-full h-96 rounded-lg overflow-hidden">
      <APIProvider apiKey={GOOGLE_MAPS_CONFIG.apiKey}>
        <Map
          style={{ width: '100%', height: '100%' }}
          defaultCenter={{ lat: latitude, lng: longitude }}
          defaultZoom={GOOGLE_MAPS_CONFIG.defaultZoom}
          gestureHandling={GOOGLE_MAPS_CONFIG.mapOptions.gestureHandling}
          disableDefaultUI={GOOGLE_MAPS_CONFIG.mapOptions.disableDefaultUI}
        >
          <Marker
            position={{ lat: latitude, lng: longitude }}
            title={title}
          />
        </Map>
      </APIProvider>
    </div>
  );
};

export default GoogleMap;
